:host {
  display: block;
  height: 18px;
  width: 26px;
  border: 1px solid @ig-grey-300;

  > a {
    display: block;
    margin: 1px;
    background-image: @flags;

    &.flag--zh {
      background-image: @flags_zh;
    }

    &.flag--cn {
      background-image: @flags_cn;
    }

    &.flag--esp,
    &.flag--latam {
      background-image: @flags_esp;
    }

    width: 24px;
    height: 16px;
    text-indent: 30px;
    white-space: nowrap;
    line-height: 20px;
    color: @white;
    text-decoration: none;

    &.flag--rus {
      text-indent: 0;
    }
  }
}

:host([country='esp']),
:host([country='rus']) {
  display: none;
}

:host([is-international='true'][country='esp']),
:host([is-international='true'][country='rus']) {
  display: block;
}

:host([is-international='true'][country='en']) {
  border: none;
}

:host([show-flag='false']) {
  border: none;
}

:host([is-international='true']) {
  > a {
    span {
      color: @black;
      .MatterSemiBold();
      position: relative;
      top: -4px;
      margin-left: 10px;
      font-size: 12px;

      &:hover {
        text-decoration: none;
      }
    }

    &.flag--rus {
      background-image: @flags;
      text-indent: 30px;
    }

    &.flag--en {
      text-indent: 0;

      span {
        margin-left: 0;
      }
    }
    &.flag--none {
      background: none;
      text-indent: 0;

      span {
        margin: 0;
      }
    }
  }
}

:host([is-footer='true'].hide-flag) {
  border: none;
  a {
    background: none;
    text-indent: 0;
  }
}

span:hover {
  text-decoration: underline;
}

.flag--ae {
  background-position: 0 -99px;
}
.flag--ar-ae {
  background-position: 100% -98px;
}
.flag--at {
  background-position: 0 -400px;
}
.flag--au {
  background-position: 0 -505px;
}
.flag--be {
  background-position: 0 -59px;
}
.flag--bg {
  background-position: 0 -79px;
}
.flag--ch {
  background-position: 0 -547px;
}
.flag--cy {
  background-position: 0 -139px;
}
.flag--cz {
  background-position: 0 -159px;
}
.flag--de,
.flag--deu {
  background-position: 0 -379px;
}
.flag--dk {
  background-position: 0 -199px;
}
.flag--ee {
  background-position: 0 -219px;
}
.flag--es {
  background-position: 0 -718px;
}
.flag--fi {
  background-position: 0 -259px;
}
.flag--fr,
.flag--fra {
  background-position: 0 -484px;
}
.flag--gr {
  background-position: 0 -299px;
}
.flag--hr {
  background-position: 0 -319px;
}
.flag--hu {
  background-position: 0 -339px;
}
.flag--ie {
  background-position: 0 -442px;
}
.flag--is {
  background-position: 0 -19px;
}
.flag--it {
  background-position: 0 -674px;
}
.flag--jp {
  background-position: 0 -421px;
}
.flag--lt {
  background-position: 0 -359px;
}
.flag--lu {
  background-position: 0 -785px;
}
.flag--lv {
  background-position: 0 -279px;
}
.flag--mt {
  background-position: 0 -239px;
}
.flag--ndx {
  background-position: 0 -526px;
}
.flag--nl {
  background-position: 0 -696px;
}
.flag--no {
  background-position: 0 -762px;
}
.flag--pl {
  background-position: 0 -179px;
}
.flag--pt,
.flag--por {
  background-position: 0 -610px;
}
.flag--ro {
  background-position: 0 -119px;
}
.flag--rus {
  background-position: 0 -631px;
}
.flag--se {
  background-position: 0 -589px;
}
.flag--sg {
  background-position: 0 -568px;
}
.flag--si {
  background-position: 0 0;
}
.flag--sk {
  background-position: 0 -39px;
}
.flag--us {
  background-position: 0 -525px;
}
.flag--uk,
.flag--en {
  background-position: 0 -463px;
}
.flag--za {
  background-position: 0 -740px;
}
.flag--en-ch,
.flag--fr-ch,
.flag--it-ch {
  background-position: 0 -547px;
}

.flag--eng {
  background-position: 0 -807px;
}
